export const environment = {
  production: false,
  apiBaseUrl: 'https://axa-mqt-api.v4.mmd-technology.com'
};
